import React from 'react';
import { User, Bell, Shield, Key } from 'lucide-react';

export interface SettingsTab {
  id: string;
  name: string;
  icon: React.ComponentType<any>;
}

interface SettingsSidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const tabs: SettingsTab[] = [
  { id: 'profile', name: 'Profile', icon: User },
  { id: 'notifications', name: 'Notifications', icon: Bell },
  { id: 'security', name: 'Security', icon: Shield },
  { id: 'api', name: 'API Keys', icon: Key },
];

const SettingsSidebar: React.FC<SettingsSidebarProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="lg:col-span-1 bg-slate-50 dark:bg-slate-900/50 lg:rounded-l-lg border-b lg:border-b-0 lg:border-r border-slate-200 dark:border-slate-700">
      <nav className="space-y-1 p-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800'
                  : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
              }`}
            >
              <Icon className="w-5 h-5 mr-3" />
              {tab.name}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default SettingsSidebar;